import {OptionType} from "../../common/searchForm/constants/Option.type";
import {AllUserTypeList} from "../../user/constants/User.type";
import {KeywordTypeList} from "./Keyword.type";
import {LicenseTypeDto} from "../dto/LicenseType.dto";
import {SearchFormPropsForUse} from "../../common/searchForm/SearchForm.props";

export const LicenseSearchFormProps = (licenseTypes: LicenseTypeDto[] = []): SearchFormPropsForUse => {
    return {
        options: [
            {
                type: OptionType.CHECK_LIST,
                key: "type",
                name: "유저 타입",
                list: AllUserTypeList.map(it => it.type),
                stringList: AllUserTypeList.map(it => it.name),
                value: [true, true, true]
            },
            {
                type: OptionType.CHECK_LIST,
                key: "licenseType",
                name: "라이선스 타입",
                list: licenseTypes.map(it => it.type),
                stringList: licenseTypes.map(it => it.name),
                value: [true, true, true]
            },
            {
                type: OptionType.TYPE_TEXT,
                key: "keyword",
                name: "검색",
                list: KeywordTypeList.map(it => it.type),
                stringList: KeywordTypeList.map(it => it.name),
                value: {
                    type: KeywordTypeList[0].type,
                    text: ""
                }
            }
        ],
        onUpdate: () => {}
    }
}